module.exports = __webpack_public_path__ + "static/media/forked.828a5a5f.png";